<template>
    <div class="lms__superadmin_users_bulk_add">
        <div class="lms__superadmin_users_bulk_add_header">
            <view-actions
                :title="'Users'"
                :custom-notify-active="false"
                :cancel-button-text="'Go to users'"
                :cancel-notify-active="false"
                :submit-button-active="false"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: 'Users',
                        to: backToUsers
                    }
                ]"
                @emit-cancel="stopAddUsers"
            />
        </div>
        <div class="lms__superadmin_users_bulk_add_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="[
                            { label: 'Upload', name: 'lms-superadmin-user-bulk-add-upload', visible: () => true },
                            { label: 'Preview', name: 'lms-superadmin-user-bulk-add-preview', visible: () => uploadedFile && availableRoles }
                        ]"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="lms__superadmin_users_bulk_add_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  name: 'lms-superadmin-users-bulk-add',
  components: { ComponentSidebar, ViewActions },
  computed: {
    backToUsers () {
      return { name: 'lms-superadmin-user-list' }
    },
    uploadedFile () {
      return Boolean(this.$store.getters.getLmsSuperadminUsersBulkFile)
    },
    availableRoles () {
      return Boolean(this.$store.getters.getLmsSuperadminCustomerRoles.length)
    }
  },
  methods: {
    stopAddUsers () {
      this.$router.push({ name: 'lms-superadmin-user-list' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkadd.scss";
</style>
